"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var Loader_1 = require("./Loader");
var iconSizeMap = {
  sm: 12,
  base: 18,
  lg: 28
};
var iconPaddingMap = {
  sm: 'mr-2',
  base: 'mr-3',
  lg: 'mr-4'
};
function Button(_a) {
  var icon = _a.icon,
    children = _a.children,
    onClick = _a.onClick,
    className = _a.className,
    disabled = _a.disabled,
    _b = _a.size,
    size = _b === void 0 ? 'base' : _b,
    ghost = _a.ghost,
    loading = _a.loading;
  var loadingContent = react_1.default.createElement(react_1.default.Fragment, null, typeof loading === 'boolean' && loading && react_1.default.createElement(Loader_1.Loader, {
    size: "xs",
    className: classnames_1.default({
      'border-white dark:border-black': !ghost,
      'border-primary dark:border-white': ghost
    })
  }), typeof loading === 'string' && react_1.default.createElement("span", {
    className: classnames_1.default({
      'dark:text-black': !ghost
    })
  }, loading));
  var childContent = react_1.default.createElement(react_1.default.Fragment, null, !!icon && react_1.default.cloneElement(icon, {
    size: iconSizeMap[size],
    className: classnames_1.default(iconPaddingMap[size], {
      'text-white dark:text-primary': !ghost,
      'text-primary dark:text-white': ghost
    })
  }), children);
  return react_1.default.createElement("button", {
    type: "button",
    className: classnames_1.default('transition-colors duration-300 flex items-center justify-center rounded font-thin tracking-wide', {
      'bg-primary hover:bg-primary-hover text-white shadow hover:shadow-lg dark:bg-white dark:text-primary dark-hover:bg-gray-300': !ghost,
      'border border-primary text-primary hover:bg-gray-100 dark:border-white dark:text-white dark-hover:bg-gray-800': ghost,
      'opacity-50': disabled || loading,
      'cursor-not-allowed': disabled,
      'cursor-wait w-32': loading,
      'py-2 px-4 text-sm': size === 'base',
      'py-4 px-6 text-base text-lg': size === 'lg',
      'px-2 text-xs': size === 'sm'
    }, className),
    onClick: function () {
      if (!disabled && !loading) {
        onClick();
      }
    }
  }, loading && loadingContent, !loading && childContent);
}
exports.Button = Button;